import { connect, MapStateToProps } from 'react-redux'
import { Props } from './CartboxPriceViewSwitcher'
import availablePriceViewsSelector from '../../redux/selectors/availablePriceViewsSelector'
import priceViewFlagSelector from '../../redux/selectors/priceViewFlagSelector'
import { switchPriceView } from '../../redux/actions/app/priceView.actions'

type StateProps = Pick<Props, 'availablePriceViews' | 'currentPriceView'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state) => ({
    availablePriceViews: availablePriceViewsSelector(state),
    currentPriceView: priceViewFlagSelector(state),
})

type DispatchProps = Pick<Props, 'switchPriceView'>

const mapDispatchToProps: DispatchProps = {
    switchPriceView: switchPriceView,
}

export default connect(mapStateToProps, mapDispatchToProps)
